import React, { createContext, useCallback, useContext, useState } from 'react';

const AlertContext = createContext(null);

export function AppAlertProvider({ children }) {
    const [alerts, setAlerts] = useState([]);

    const removeAlert = useCallback((id) => {
        setAlerts((prev) => prev.filter((alert) => alert.id !== id));
    }, []);

    const addAlert = useCallback((message, type = 'success') => {
        const text = typeof message === 'string' ? message : message?.message || 'Action completed';
        if (!text) return;

        const id = Date.now() + Math.random();
        setAlerts((prev) => [...prev, { id, message: text, type }]);
        window.setTimeout(() => removeAlert(id), 4200);
    }, [removeAlert]);

    return (
        <AlertContext.Provider value={addAlert}>
            {children}
            <div className="app-alerts" aria-live="polite" aria-atomic="true">
                {alerts.map((alert) => (
                    <div
                        key={alert.id}
                        className={`app-alert app-alert--${alert.type}`}
                        role="alert"
                    >
                        {alert.message}
                    </div>
                ))}
            </div>
        </AlertContext.Provider>
    );
}

export function useAppAlert() {
    const context = useContext(AlertContext);
    if (!context) {
        return () => {};
    }
    return context;
}
